<template>
    <div>
        <!--Start Middle content-->
        <!--Start internal page banner section-->
        <section class="internal-page-banner-main col-12">
            <div class="container">
                <div class="row">
                    <div class="page-title">
                        <h1> Dayforce 101
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2 pull-right">
                                <v-select  class="" v-model="categoryId"
                                           @change="changedValue"
                                           @input="changedCategoryFor()"
                                           name="categoryId"
                                           id="categoryId"
                                           label="text"
                                           :filterable="false"
                                           :options="categoryArr"
                                           @search="onSearchCategory"
                                           placeholder="Select Category">
                                    <template slot="no-options">
                                        Search Parent Category...
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.text }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.text }}
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </h1>
                    </div>
                </div>
            </div>
        </section>
        <!--End internal page banner section-->
        <div class="col-12 float-l width-full">
            <div class="container">
                <div class="row">

                                <div class="forms-policy-main-section col-12 float-l">
                                    <div class="row">
                                        <!--Dynamic Content-->
                                        <template v-for="(text, index) in dayfoceDocList">
                                            <div class="forms-detail-main col-12 float-l"> <!--forth policy-->
                                                <div class="row">
                                                    <template v-if="(index + 1) % 2 == 0">
                                                        <div class="left-policy-img col-12 col-sm-5 col-md-5 col-lg-5 pull-right">
                                                            <img :src="text.image_path" />
                                                        </div>
                                                    </template>
                                                    <template v-if="(index + 1) % 2 != 0">
                                                        <div class="left-policy-img col-12 col-sm-5 col-md-5 col-lg-5 pull-left">
                                                            <img :src="text.image_path" />
                                                        </div>
                                                    </template>

                                                    <div class="right-policy-text col-12 col-sm-7 col-md-7 col-lg-7 pull-left">
                                                        <h2 class="heading-text-20 line-height-22 color-red font-text-bold-mont ucase"> {{text.title}} </h2>
                                                        <!--<p class="heading-text-16 line-height-20 color-333333 font-text-semi-medium-mont mb-30"> {{text.description}} <a class="internal-link" href="https://usr54.dayforcehcm.com/CandidatePortal/en-US/LATruck" target="_blank"> Go to Dayforce  </a> </p>-->
                                                        <p class="dayforce-right-title heading-text-16 line-height-20 color-333333 font-text-semi-medium-mont mb-30" v-html="text.description" v-linkified:options="{ className: 'internal-link' }" v-linkified></p>
                                                        <!--<p class="heading-text-16 line-height-20 color-333333 font-text-semi-medium-mont mb-30"> Please contact Human Resources at <a class="internal-link" href="mailto:hr@vvgtruck.com" target="_blank"> hr@vvgtruck.com </a> </p>-->
                                                        <p class="heading-text-16 line-height-20 color-333333 font-text-semi-medium-mont mb-30" v-html="text.contact_description" v-linkified:options="{ className: 'internal-link' }" v-linkified></p>
                                                        <div class="benefit-links-section-left-1 col-12">
                                                            <div class="row">
                                                                <template v-for="(btn, index) in text.button_array">
                                                                    <p>
                                                                        <template v-if="btn.button_document != ''">
                                                                            <!-- <a :href="btn.button_document" target="_blank" class="hvr-sweep-to-right-blue"> -->
                                                                            <a href="#" :id="'id' + index" @click="getSignedUrlPath(btn.button_document)" class="hvr-sweep-to-right-blue">
                                                                                {{btn.button_title}}
                                                                            </a>
                                                                        </template>
                                                                        <template v-if="btn.button_url != ''">
                                                                            <a :href="btn.button_url" target="_blank" class="hvr-sweep-to-right-blue">
                                                                                {{btn.button_title}}
                                                                            </a>
                                                                        </template>
                                                                    </p>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <!--End Dynamic Content-->

                                    </div>
                                </div>



                    <!--<div class="select-development-box-main col-12 float-r">
                        <div class="row">
                            <p class="color-888888 heading-text-14 line-height-16 font-text-semi-medium-mont float-l pt-12 pr-20"> Select One Category: </p>
                            <v-select  class="leadership-category pull-right" v-model="categoryId"
                                       @change="changedValue"
                                       @input="changedCategoryFor()"
                                       name="categoryId"
                                       id="categoryId"
                                       label="text"
                                       :filterable="false"
                                       :options="categoryArr"
                                       @search="onSearchCategory"
                                       placeholder="Select Parent Category">
                                <template slot="no-options">
                                    Search Parent Category...
                                </template>
                                <template slot="option" slot-scope="option">
                                    <div class="d-center">
                                        {{ option.text }}
                                    </div>
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    <div class="selected d-center">
                                        {{ option.text }}
                                    </div>
                                </template>
                            </v-select>
                        </div>
                    </div>-->
                    <div class="dayforce-main-section col-12 float-l">
                        <div class="row">
                            <!--<div class="view-btn-small pt-20 pb-80 col-12">
                                <div class="row">
                                    <a href="#" class="hvr-sweep-to-right-blue"> Login in Dayforce </a>
                                </div>
                            </div>-->

                            <div class="">
                                <template v-for="(text, index) in dayforceList">
                                    <div class="bottom-listing-prog-des dayforce-video-detail-left col-12 col-sm-12 col-md-6 col-lg-6 float-l"> <!--First des-->
                                        <div class="daygorce-detail-inner width-full float-l">
                                            <div class="hover-home-eefect float-l width-full">
                                                <template v-if="text.video_url != ''">
                                                    <iframe class="width-full" width="560" height="300" :src="text.video_url" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                                </template>
                                                <template v-else>
                                                    <video class="width-full" width="560"  height="300" controls="controls" preload="metadata">
                                                        <source :src="text.video_path + '#t=0.5'" type="video/mp4">
                                                    </video>
                                                    <!--<iframe class="width-full" width="560" height="300" :src="text.video_path" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
                                                </template>
                                                <!--<a href="https://youtu.be/Ad0NIU9TVh8" target="_blank"> <img src="/static/images/dayforce-1-img.jpg" alt="Job Req Video"> </a>-->
                                            </div>
                                            <h3 class="leading-title float-l width-full heading-text-16 line-height-20 ucase font-text-semi-medium-mont"> {{text.video_title}} </h3>
                                            <p class="leaning-detail float-l color-333333 heading-text-14 line-height-18 font-text-semi-medium-mont"> {{text.description}} </p>
                                            <div class="btm-video-link width-full float-l">
                                                <template v-if="text.video_url != ''">
                                                    <a class="heading-text-164 font-text-semi-medium-mont" :href="text.video_url" target="_blank"> Click here to view video </a> <!-- <a href="https://youtu.be/Ad0NIU9TVh8" target="_blank"> https://youtu.be/Ad0NIU9TVh8 </a> -->
                                                </template>
                                                <template v-else>
                                                    <a class="heading-text-164 font-text-semi-medium-mont" :href="text.video_path" target="_blank"> Click here to view video </a> <!-- <a href="https://youtu.be/Ad0NIU9TVh8" target="_blank"> https://youtu.be/Ad0NIU9TVh8 </a> -->
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                    <template v-if="(index + 1) % 2 == 0">
                                        <div class="clearfix float-l width-full"></div>
                                    </template>
                                </template>
                                <!--<div class="bottom-listing-prog-des dayforce-video-detail-left col-12 col-sm-6 col-md-6 col-lg-6 float-l"> &lt;!&ndash;First des&ndash;&gt;-->
                                <!--<div class="daygorce-detail-inner width-full float-l">-->
                                <!--<div class="hover-home-eefect float-l width-full">-->
                                <!--<iframe class="width-full" width="560" height="300" src="https://www.youtube.com/embed/Ad0NIU9TVh8" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
                                <!--&lt;!&ndash;<a href="https://youtu.be/Ad0NIU9TVh8" target="_blank"> <img src="/static/images/dayforce-1-img.jpg" alt="Job Req Video"> </a>&ndash;&gt;-->
                                <!--</div>-->
                                <!--<h3 class="leading-title float-l width-full heading-text-16 line-height-20 ucase font-text-semi-medium-mont"> Job Req Video </h3>-->
                                <!--<p class="leaning-detail float-l color-333333 heading-text-14 line-height-18 font-text-semi-medium-mont"> Submit a Job Requisition (Job Req) when you are ready to fill a position. This video will show you how to submit a job req through dayforce. </p>-->
                                <!--<div class="btm-video-link width-full float-l">-->
                                <!--<a class="heading-text-164 font-text-semi-medium-mont" href="https://youtu.be/Ad0NIU9TVh8" target="_blank"> Click here to view video </a> &lt;!&ndash; <a href="https://youtu.be/Ad0NIU9TVh8" target="_blank"> https://youtu.be/Ad0NIU9TVh8 </a> &ndash;&gt;-->
                                <!--</div>-->
                                <!--</div>-->
                                <!--</div> &lt;!&ndash;First des&ndash;&gt;-->
                                <!--<div class="bottom-listing-prog-des dayforce-video-detail-right col-12 col-sm-6 col-md-6 col-lg-6 float-l"> &lt;!&ndash;second des&ndash;&gt;-->
                                <!--<div class="daygorce-detail-inner width-full float-l">-->
                                <!--<div class="hover-home-eefect float-l width-full">-->
                                <!--<iframe class="width-full" width="560" height="300" src="https://www.youtube.com/embed/54Lc8uWd9sM" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
                                <!--&lt;!&ndash;<a href="https://youtu.be/54Lc8uWd9sM" target="_blank"> <img src="/static/images/dayforce-2-img.jpg" alt="View Candidates"> </a>&ndash;&gt;-->
                                <!--</div>-->
                                <!--<h3 class="leading-title float-l width-full heading-text-16 line-height-20 ucase font-text-semi-medium-mont pt-28"> View Candidates </h3>-->
                                <!--<p class="leaning-detail float-l color-333333 heading-text-14 line-height-18 font-text-semi-medium-mont"> Once a job req is submitted, go to the recruiting module to view candidates. This video will show you how to navigate and view candidates that have applied. </p>-->
                                <!--<div class="btm-video-link width-full float-l">-->
                                <!--<a class="heading-text-164 font-text-semi-medium-mont" href="https://youtu.be/54Lc8uWd9sM" target="_blank"> Click here to view video </a> &lt;!&ndash; <a href="https://youtu.be/Ad0NIU9TVh8" target="_blank"> https://youtu.be/Ad0NIU9TVh8 </a> &ndash;&gt;-->
                                <!--</div>-->
                                <!--</div>-->
                                <!--</div> &lt;!&ndash;second des&ndash;&gt;-->
                                <!--<div class="bottom-listing-prog-des dayforce-video-detail-left col-12 col-sm-6 col-md-6 col-lg-6 float-l"> &lt;!&ndash;third des&ndash;&gt;-->
                                <!--<div class="daygorce-detail-inner width-full float-l">-->
                                <!--<div class="hover-home-eefect float-l width-full">-->
                                <!--<iframe class="width-full" width="560" height="300" src="https://www.youtube.com/embed/xBC6GD0-Jko" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
                                <!--&lt;!&ndash;<a href="https://youtu.be/xBC6GD0-Jko" target="_blank"> <img src="/static/images/dayforce-3-img.jpg" alt="Send Offer"> </a>&ndash;&gt;-->
                                <!--</div>-->
                                <!--<h3 class="leading-title float-l width-full heading-text-16 line-height-20 ucase font-text-semi-medium-mont pt-28"> Send Offer </h3>-->
                                <!--<p class="leaning-detail float-l color-333333 heading-text-14 line-height-18 font-text-semi-medium-mont"> Once you’ve found your perfect candidate, you will need to send them an offer letter. Watch this video to learn how to send offer. </p>-->
                                <!--<div class="btm-video-link width-full float-l">-->
                                <!--<a class="heading-text-164 font-text-semi-medium-mont" href="https://youtu.be/xBC6GD0-Jko" target="_blank"> Click here to view video </a> &lt;!&ndash; <a href="https://youtu.be/Ad0NIU9TVh8" target="_blank"> https://youtu.be/Ad0NIU9TVh8 </a> &ndash;&gt;-->
                                <!--</div>-->
                                <!--</div>-->
                                <!--</div> &lt;!&ndash;third des&ndash;&gt;-->
                                <!--<div class="bottom-listing-prog-des dayforce-video-detail-right col-12 col-sm-6 col-md-6 col-lg-6 float-l"> &lt;!&ndash;forth des&ndash;&gt;-->
                                <!--<div class="daygorce-detail-inner width-full float-l">-->
                                <!--<div class="hover-home-eefect float-l width-full">-->
                                <!--<iframe class="width-full" width="560" height="300" src="https://www.youtube.com/embed/drK-MTCzJhI" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
                                <!--&lt;!&ndash;<a href="https://youtu.be/drK-MTCzJhI" target="_blank"> <img src="/static/images/dayforce-4-img.jpg" alt="Hire Candidate"> </a>&ndash;&gt;-->
                                <!--</div>-->
                                <!--<h3 class="leading-title float-l width-full heading-text-16 line-height-20 ucase font-text-semi-medium-mont pt-28"> Hire Candidate </h3>-->
                                <!--<p class="leaning-detail float-l color-333333 heading-text-14 line-height-18 font-text-semi-medium-mont"> When you have confirmed start date, next step is to click the hire button. This video will go over how to locate and complete candidate hire form. </p>-->
                                <!--<div class="btm-video-link width-full float-l">-->
                                <!--<a class="heading-text-164 font-text-semi-medium-mont" href="https://youtu.be/drK-MTCzJhI" target="_blank"> Click here to view video </a> &lt;!&ndash; <a href="https://youtu.be/Ad0NIU9TVh8" target="_blank"> https://youtu.be/Ad0NIU9TVh8 </a> &ndash;&gt;-->
                                <!--</div>-->
                                <!--</div> &lt;!&ndash;forth des&ndash;&gt;-->
                                <!--</div>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--End Middle content-->
    </div>
</template>
<script>
    import Vue from "vue";
    import vSelect from 'vue-select';
    import SessioMixin from '../mixins/sessionmixin';
    import { HTTP } from '../http-common';
    import draggable from 'vuedraggable';
    var self;
    export default {
        name: 'dayforce101',
        components: {
            'v-select': vSelect,
            draggable,
        },
        mixins: [SessioMixin],
        data() {
            return {
                categoryId: '',
                categoryArr: [],
                categoryType: 'dayforce',
                dayforceList: [],
                dayfoceDocList : [],
            }
        },
        watch: {
            categoryId: function (categoryId) {
                self.getDayForce101();
            }
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },
        mounted: function () {
            self.MenuClose();
            self.loadCategoryFirst();
            self.getDayforceDocData();
            self.getBuildVersion();
        },

        methods: {
            getDayforceDocData() {
                var path = window.location.pathname;
                var segments = path.split("/");
                // var roleId = (self.roleId === null || self.roleId == '') ? 0 : self.roleId.value;
                // var locationId = (self.locationId === null || self.locationId == '') ? 0 : self.locationId.value;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    // params: {
                    //     role_id: roleId,
                    //     location_id: locationId,
                    // }
                };

                HTTP.post("getdayforcedocdata", '', config)
                    .then(function (response) {
                        self.dayfoceDocList = [];
                        setTimeout(function () {
                            self.dayfoceDocList = response.data.content;
                        }, 100);
                    })
                    .catch(function (err) {

                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            loadCategoryFirst() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        'type': self.categoryType,
                    }
                };
                HTTP.get("getcategory", config)
                    .then(function (response) {
                        self.categoryArr = [];
                        var addAll = {text: 'All', value: '0'};
                        self.categoryArr.push(addAll);
                        $.each(response.data.content, function (i) {
                            self.categoryArr.push(response.data.content[i]);
                        });
                        self.categoryId = addAll;
//                        self.categoryArr = response.data.content;
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                self.$router.push("/login");
                                //EventBus.$emit("logged-in", true, "", "");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            },
            changedValue: function (value) {
                //console.log(value);
            },
            changedCategoryFor: function () {

            },
            onSearchCategory(search, loading) {
                if (search.length >= 2) {
                    if (typeof (loading) != "undefined") {
                        loading(true);
                    }
                    this.loadCategory(loading, search, this);
                }
            },
            loadCategory(loading, search, vm) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        'type': self.categoryType,
                        'search': search,
                    }

                };
                HTTP.get("getcategory", config)
                    .then(function (response) {
                        self.categoryArr = response.data.content;
                        if (typeof (loading) != "undefined") {
                            loading(false);
                        }
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                self.$router.push("/login");
                                //EventBus.$emit("logged-in", true, "", "");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            },

            getDayForce101: function () {
                var fields = {
                    categoryId: self.categoryId.value,
                    categoryType: self.categoryType,
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post('getdayforce101/' + self.categoryId.value, fields, config).
                then(response => {
                    self.dayforceList = [];
                    setTimeout(function () {
                        self.dayforceList = response.data.content;
                    }, 100);
                })
                    .catch(function (err) {
                        self.dayforceList = [];
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                self.$router.push("/login");
                                //EventBus.$emit("logged-in", true, "", "");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/DayForce101.vue